// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkage-check[data-v-db258cd2]{padding-left:24px;display:inline-block;height:40px;line-height:40px}.title[data-v-db258cd2]{text-align:center;margin:20px 0}.remarks[data-v-db258cd2]{height:30px;line-height:30px;color:#666;padding-left:24px;margin-top:6px}", ""]);
// Exports
module.exports = exports;
